import { getSignedURL } from '@SonarCX/lib/api'
import { isEmpty } from '..'

export const ID_ATTR = 'sonar-id'

export const parseAsHTML = (text: string) => {
  const root = document.createElement('html')
  root.innerHTML = text
  const images = root.getElementsByTagName('img')
  return { root, images }
}

export const isBase64Image = (text: string) => {
  const regex =
    /^data:image\/png;base64,([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/
  return regex.test(text)
}

// Converts images with base64 sources to id
export const loadImages = async (text: string) => {
  if (isEmpty(text)) {
    return ''
  }

  const { root, images } = parseAsHTML(text)

  for (const img of images) {
    // Load image from id
    if (img.hasAttribute(ID_ATTR)) {
      const id = img.getAttribute(ID_ATTR)
      img.src = await getSignedURL(id)
    }
  }

  return root.innerHTML
}
